import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '_helpers';
import { alertActions } from './alert.slice';

const name = 'map';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports
export const mapActions = { ...slice.actions, ...extraActions };
export const mapReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        center : {
            lat: 46.90299323764274,
            lng: -0.6920310981106956
        },
        lastPositions: null,
        poi: null,
        fleet: null,
        fleetAutorefresh: false,
        autoRefresh: false,
        error: null,
        isLoading: false,
        layerVisibility: {
            buses: true,
            alerts: true,
            stops: true,
            routes: false,
            depots: false,
            dealerships: false,
            pantographs: false,
        },
    };
}

function createReducers() {
    return {        
        setCenter,
        toggleAutoRefresh,
        toggleFleetAutoRefresh,
        clearData,
        setLayerVisibility,
    };

    function setCenter(state, action) {
        state.center = action.payload;
    }

    function toggleAutoRefresh(state, action) {
        state.autoRefresh = action.payload;
    }

    function toggleFleetAutoRefresh(state, action) {
        state.fleetAutorefresh = action.payload;
    }

    function clearData(state, action) {
        state.center = {
            lat: 46.90299323764274,
            lng: -0.6920310981106956
        };
        state.lastPositions =  null;
        state.poi =  null;
        state.autoRefresh = false;
    }

    function setLayerVisibility(state, action) {
        const { layerId, visibility } = action.payload;
        state.layerVisibility[layerId] = visibility;
    }

}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getLastPositions: getLastPositions(),
        getPoi: getPoi(),
        getFleetInfo: getFleetInfo()
    };

    function getLastPositions() {
        return createAsyncThunk(
            `${name}/getLastPositions`,
            async function(queryParams, { dispatch }) {
                try {
                    //const url = `${baseUrl}/last_positions${filter_id ? `?filter_id=${filter_id}` : ''}`;
                    //const data = await fetchWrapper.get(url);
                    const data = await fetchWrapper.get(`${baseUrl}/last_positions?${queryParams}`);
                    dispatch(alertActions.success({message: 'Actualisation des emplacement des bus', showAfterRedirect: true}))
                    return data;
                }catch (error) {
                    dispatch(alertActions.error({message: "Erreur lors de l'acualisation des des emplacement des bus", showAfterRedirect: true}));
                }

            }
        );
    }

    function getPoi() {
        return createAsyncThunk(
            `${name}/getAll`,
            async function(arg, { dispatch }) {
                try {
                    const data = await fetchWrapper.get(`${baseUrl}/poi`);
                    dispatch(alertActions.success({message: 'Actualisation des poi', showAfterRedirect: true}))
                    return data;
                }catch (error) {
                    dispatch(alertActions.error({message: "Erreur lors de l'acualisation des poi", showAfterRedirect: true}));
                }

            }
        );
    }

    function getFleetInfo() {
        return createAsyncThunk(
            `${name}/getFleetInfo`,
            async function(fleet, { dispatch }) {
                try {
                    const data = await fetchWrapper.get(`${baseUrl}/fleet?metropolis=${fleet}`);
                    dispatch(alertActions.success({message: 'Récupération des données de flotte', showAfterRedirect: true}))
                    return data;
                }catch (error) {
                    dispatch(alertActions.error({message: "Erreur lors de la récupération des données de flotte", showAfterRedirect: true}));
                }
            }
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getLastPositions();
        getPoi();   
        getFleetInfo();     

        function getLastPositions() {
            var { pending, fulfilled, rejected } = extraActions.getLastPositions;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                    state.lastPositions = { ...state.lastPositions, loading: true, error: null };
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.lastPositions = { ...state.lastPositions, value: action.payload, loading: false, error: null };
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.lastPositions = { ...state.lastPositions, error: action.error, loading: false };
                });
        }

        function getPoi() {
            var { pending, fulfilled, rejected } = extraActions.getPoi;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.poi = action.payload;
                    //state.initialData = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des poi';
                });
        }

        function getFleetInfo() {
            var { pending, fulfilled, rejected } = extraActions.getFleetInfo;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.fleet = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des poi';
                });
        }
    };
}

export default mapReducer;

